import { AvatarEditor } from '../AvatarEditor';
import { FormSection } from '../ui/FormSection';
import type { RefObject } from 'react';
import type { AvatarEditorHandle } from '../AvatarEditor';

interface OnboardingStepPhotoProps {
  editorRef: RefObject<AvatarEditorHandle>;
  userId: string;
  currentAvatarUrl: string | undefined;
  onAvatarChange: (url: string | null) => void;
}

/**
 * Step 3 — profile photo. The page keeps the editor ref so it can commit a
 * pending crop when onboarding is submitted.
 */
export const OnboardingStepPhoto = ({
  editorRef,
  userId,
  currentAvatarUrl,
  onAvatarChange,
}: OnboardingStepPhotoProps) => (
  <FormSection
    title="Photo"
    description="Add a profile photo to personalize your account. You can skip this step and add one later."
    divider={false}
    className="mt-0"
  >
    <AvatarEditor
      ref={editorRef}
      userId={userId}
      currentAvatarUrl={currentAvatarUrl}
      onAvatarChange={onAvatarChange}
    />
  </FormSection>
);
